import styled from 'styled-components';
export const IconWrapper = styled.div `
  cursor: pointer;
  display: inline-flex;
`;
